module.exports = __webpack_public_path__ + "img/search-o.27f02e0d.svg";